import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Config, TakerDataService} from '../../../modules/hbs-services';

@Injectable()
export class ConfigService {

    constructor(private dataService: TakerDataService) {
    }

    loadConfig(forSignedUser: boolean) {
        return this.dataService.getConfig(forSignedUser)
            .pipe(map(data => Config.deserialize(data)));
    }

}
